import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { BaseComponent } from 'src/app/moov-common/base/base.component';
import { SelectableResponseStateEnum } from '../discovery-process.enum';

@Component({
  selector: 'app-discovery-wizard-selectable-response',
  templateUrl: './discovery-wizard-selectable-response.component.html',
  styleUrls: ['./discovery-wizard-selectable-response.component.scss']
})
export class DiscoveryWizardSelectableResponseComponent extends BaseComponent implements OnInit {
  @Input() responseState: SelectableResponseStateEnum = SelectableResponseStateEnum.Enabled;
  @Input() isGreyedOut: boolean = false;

  @Input() responseText: string = "";
  @Input() responseId: string = "";
  @Output() responseSelected =  new EventEmitter();
  bkColor : string = ENABLED_BK_COLOR;
  iconColor: string = ENABLED_ICON_COLOR;
  responseBkColor: string = RESPONSE_DEFAULT_BK_COLOR;

  constructor() { 
    super();
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.calculateVisual();
  }

  ngOnChanges(changes: SimpleChanges): void {

    if (!changes.reponseState || !changes.isGreyedOut){
      // This is done as Angular sucks.
      return;
    }

    if ((changes.reponseState.currentValue != changes.reponseState.previousValue && !changes.reponseState.firstChange) ||
        (changes.isGreyedOut.currentValue != changes.isGreyedOut.previousValue && !changes.isGreyedOut.firstChange)){
          this.calculateVisual();
      }
    }

  calculateVisual(): void{
    if (this.responseState == SelectableResponseStateEnum.Disabled){
      this.bkColor = DISABLED_BK_COLOR;
      this.iconColor = DISABLED_ICON_COLOR;
      this.responseBkColor = RESPONSE_DEFAULT_BK_COLOR;
    }
    else if (this.responseState == SelectableResponseStateEnum.Selected){
      this.bkColor = SELECTED_BK_COLOR;
      this.iconColor = SELECTED_ICON_COLOR;
      this.responseBkColor = RESPONSE_SELECTED_BK_COLOR;
    }
    else{ /*everything else - actually - if (this.responseState == SelectableResponseStateEnum.Enabled)*/
      this.bkColor = ENABLED_BK_COLOR;
      this.iconColor = ENABLED_ICON_COLOR;
      this.responseBkColor = RESPONSE_DEFAULT_BK_COLOR;
    }
  }

  emitResposneSelectedEvent(){
    this.responseSelected.emit();
  }
}

const SELECTED_ICON_COLOR = "#FFFFFF";
const SELECTED_BK_COLOR = "#2CA9F5";
const DISABLED_ICON_COLOR = "#878787";
const DISABLED_BK_COLOR = "#F3F3F3";
const ENABLED_BK_COLOR = "#EDF7ED";
const ENABLED_ICON_COLOR = "#2CA9F5";
const RESPONSE_DEFAULT_BK_COLOR = "#E0E0E0";
const RESPONSE_SELECTED_BK_COLOR = "#A1DEFB";